import { Scale, Award, Users } from "lucide-react";

const FOUNDER_IMAGE = "https://customer-assets.emergentagent.com/job_property-counsel-1/artifacts/uauvgpfg_0c95d15d-c996-4b43-be07-98d9bf22bd15.jpeg";

export const FounderSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="founder-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            Leadership
          </span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl text-white mt-4 md:mt-6">
            About the Founder
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-5 md:mt-6" />
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-20 items-center max-w-5xl mx-auto">
          {/* Image - Always first on mobile */}
          <div className="relative flex justify-center order-1">
            <div className="relative w-[240px] md:w-[300px] lg:w-[360px]">
              {/* Gold frame accent - desktop only */}
              <div className="absolute -inset-3 border border-[#D4AF37]/20 hidden lg:block" />
              
              <img
                src={FOUNDER_IMAGE}
                alt="Precious Ohiri-Leghemo"
                className="w-full h-auto object-cover"
                data-testid="founder-image"
              />
              
              {/* Title badge */}
              <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 lg:left-auto lg:translate-x-0 lg:-right-4 lg:-bottom-4 bg-[#D4AF37] text-[#0A0A0B] px-4 py-2 md:px-5 md:py-3 text-center lg:text-left">
                <p className="font-['Playfair_Display'] text-xs md:text-sm font-bold whitespace-nowrap">Founder & Principal Counsel</p>
              </div>
            </div>
          </div>

          {/* Content - Always second on mobile */}
          <div className="order-2 text-center lg:text-left mt-6 lg:mt-0">
            <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl text-white mb-2">
              Precious Ohiri-Leghemo
            </h3>
            <p className="text-[#D4AF37] text-[11px] md:text-xs tracking-[0.1em] md:tracking-wider uppercase mb-6 md:mb-8">
              LL.B, BL, IMBA (Distinction), Birmingham City University
            </p>
            
            <div className="space-y-5 md:space-y-6 text-white/60 text-sm md:text-base leading-[1.8] md:leading-[1.9] max-w-md mx-auto lg:mx-0">
              <p>
                Precious Ohiri-Leghemo founded 4 ACES Attorneys to provide strategic legal 
                counsel for discerning investors navigating Nigeria's real estate market.
              </p>
              <p>
                Her practice focuses on property due diligence, title verification, and 
                acquisition advisory—combining legal precision with strategic insight to 
                protect client investments and support secure real estate transactions.
              </p>
              <p>
                With over 15 years of legal practice and advisory experience, she works with 
                investors in Nigeria and the global diaspora seeking clarity, security, and 
                confidence in property acquisitions.
              </p>
            </div>

            {/* Expertise tags */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 md:gap-3 mt-6 md:mt-8">
              <div className="flex items-center gap-2 border border-[#D4AF37]/30 px-3 py-1.5 md:px-4 md:py-2">
                <Scale className="w-3 h-3 md:w-4 md:h-4 text-[#D4AF37]" />
                <span className="text-white/70 text-xs">Property Law</span>
              </div>
              <div className="flex items-center gap-2 border border-[#D4AF37]/30 px-3 py-1.5 md:px-4 md:py-2">
                <Award className="w-3 h-3 md:w-4 md:h-4 text-[#D4AF37]" />
                <span className="text-white/70 text-xs">Due Diligence</span>
              </div>
              <div className="flex items-center gap-2 border border-[#D4AF37]/30 px-3 py-1.5 md:px-4 md:py-2">
                <Users className="w-3 h-3 md:w-4 md:h-4 text-[#D4AF37]" />
                <span className="text-white/70 text-xs">Diaspora Advisory</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
